/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Button, Modal, InputLabel } from "@mui/material";
import { useForm } from "react-hook-form";
import ModalBox from "../../themes/overrides/ModalBox";
import OutlinedInput from "../../themes/overrides/OutlinedInput";
import LoadingOverlay from "../../components/LoadingOverlay";
import { addClient, updateClient } from "../../actions/oauthAction";

const AddClient = ({ isOpen, onClose, onSubmitSuccess, editMode, client }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const err = useSelector((state) => state.oauth.error);

  // Form setup using react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      redirectUri: "",
    },
  });

  //submit handler
  const onSubmit = async (data) => {
    if (!data.name) {
      setError("Client Name is required.");
      return;
    }

    if (!data.redirectUri) {
      setError("Redirect URI is required.");
      return;
    }

    setLoading(true);
    try {
      if (editMode) {
        const editFormData = new FormData();
        editFormData.append("name", data.name);
        editFormData.append("redirectUri", data.redirectUri);

        const success = await dispatch(updateClient(client._id, editFormData));
        if (success) {
          onSubmitSuccess(success);
          reset();
          onClose();
        }
      } else {
        const success = await dispatch(addClient(data));
        if (success) {
          onSubmitSuccess(success);
          reset();
          onClose();
        }
      }
    } catch (error) {
      setError(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Effect to set initial values when in edit mode
  useEffect(() => {
    if (editMode && client) {
      setValue("name", client.name);
      setValue("redirectUri", client.redirectUri);
    } else {
      reset();
    }
  }, [editMode, client]);

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <ModalBox
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{
            width: { xs: "95%", sm: "600px", md: "700px" },
            maxHeight: { xs: "95vh", sm: "90vh" },
          }}
        >
          <Typography variant="h2" sx={{ marginBottom: 2 }}>
            {editMode ? "Edit Client" : "Add Client"}
          </Typography>
          <InputLabel shrink htmlFor="name">
            Client Name
          </InputLabel>
          <OutlinedInput
            fullWidth
            name="name"
            {...register("name", { required: "Client Name is required" })}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
          <InputLabel shrink htmlFor="redirectUri">
            Redirect URI
          </InputLabel>
          <OutlinedInput
            fullWidth
            name="redirectUri"
            type="url"
            {...register("redirectUri")}
            maxRows={4}
          />

          {(error || err) && (
            <Typography variant="body2" color="error" sx={{ marginBottom: 2 }}>
              {error || err}
            </Typography>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
          >
            Publish
          </Button>
          {loading && <LoadingOverlay />}
        </ModalBox>
      </Modal>
    </>
  );
};

export default AddClient;
